import { TOGGLELAYOUT } from "../constants"

export const toggleLayoutAction = layoutType => ({
  type: TOGGLELAYOUT,
  layoutType,
})
